/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateServerForm,
  UpdateServerForm$Outbound,
  UpdateServerForm$outboundSchema,
} from "../components/updateserverform.js";

export type UpdateRemoteMcpServerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpdateRemoteMcpServerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpdateRemoteMcpServerSecurity = {
  option1?: UpdateRemoteMcpServerSecurityOption1 | undefined;
  option2?: UpdateRemoteMcpServerSecurityOption2 | undefined;
};

export type UpdateRemoteMcpServerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateServerForm: UpdateServerForm;
};

/** @internal */
export type UpdateRemoteMcpServerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpdateRemoteMcpServerSecurityOption1$outboundSchema: z.ZodMiniType<
  UpdateRemoteMcpServerSecurityOption1$Outbound,
  UpdateRemoteMcpServerSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateRemoteMcpServerSecurityOption1ToJSON(
  updateRemoteMcpServerSecurityOption1: UpdateRemoteMcpServerSecurityOption1,
): string {
  return JSON.stringify(
    UpdateRemoteMcpServerSecurityOption1$outboundSchema.parse(
      updateRemoteMcpServerSecurityOption1,
    ),
  );
}

/** @internal */
export type UpdateRemoteMcpServerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpdateRemoteMcpServerSecurityOption2$outboundSchema: z.ZodMiniType<
  UpdateRemoteMcpServerSecurityOption2$Outbound,
  UpdateRemoteMcpServerSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function updateRemoteMcpServerSecurityOption2ToJSON(
  updateRemoteMcpServerSecurityOption2: UpdateRemoteMcpServerSecurityOption2,
): string {
  return JSON.stringify(
    UpdateRemoteMcpServerSecurityOption2$outboundSchema.parse(
      updateRemoteMcpServerSecurityOption2,
    ),
  );
}

/** @internal */
export type UpdateRemoteMcpServerSecurity$Outbound = {
  Option1?: UpdateRemoteMcpServerSecurityOption1$Outbound | undefined;
  Option2?: UpdateRemoteMcpServerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpdateRemoteMcpServerSecurity$outboundSchema: z.ZodMiniType<
  UpdateRemoteMcpServerSecurity$Outbound,
  UpdateRemoteMcpServerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpdateRemoteMcpServerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpdateRemoteMcpServerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function updateRemoteMcpServerSecurityToJSON(
  updateRemoteMcpServerSecurity: UpdateRemoteMcpServerSecurity,
): string {
  return JSON.stringify(
    UpdateRemoteMcpServerSecurity$outboundSchema.parse(
      updateRemoteMcpServerSecurity,
    ),
  );
}

/** @internal */
export type UpdateRemoteMcpServerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateServerForm: UpdateServerForm$Outbound;
};

/** @internal */
export const UpdateRemoteMcpServerRequest$outboundSchema: z.ZodMiniType<
  UpdateRemoteMcpServerRequest$Outbound,
  UpdateRemoteMcpServerRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateServerForm: UpdateServerForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      updateServerForm: "UpdateServerForm",
    });
  }),
);

export function updateRemoteMcpServerRequestToJSON(
  updateRemoteMcpServerRequest: UpdateRemoteMcpServerRequest,
): string {
  return JSON.stringify(
    UpdateRemoteMcpServerRequest$outboundSchema.parse(
      updateRemoteMcpServerRequest,
    ),
  );
}
